import { createSelector } from 'reselect';

export const getProduct = (state) => state.productData;

export const getBriefsSC = createSelector(
  getProduct,
  (productData) => productData.briefs
);

export const getBriefsLoadingSC = createSelector(
  getProduct,
  (productData) => productData.briefsLoading
);

export const getPluginInfo = createSelector(
  getProduct,
  (productData) => productData.pluginInfo
);

export const getAdobeRatingSC = createSelector(
  getProduct,
  (productData) => productData.adobeRating
);

export const getRatingLoadingSC = createSelector(
  getProduct,
  (productData) => productData.ratingLoading
);

export const getRatingPaginationSC = createSelector(
  getProduct,
  (productData) => productData.ratingPagination
);

export const getRatingPreviewSC = createSelector(
  getProduct,
  (productData) => productData.ratingPreview
);

export const getRatingHistorySC = createSelector(
  getProduct,
  (productData) => productData.ratingHistory
);
